import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import qs from 'qs';
import toast from 'react-hot-toast';

import { API_URL, get } from 'lib/network/api';
import CardContentClasses from './ComponentsPage/CardContentClasses';
import Tabs from 'components/Tabs';

const fetchMyClasses = async (params, bookingStatus) => {
  const queryString = qs.stringify(
    {
      page: params?.page || 1,
      limit: params?.limit || 50,
      booking_type: 'class',
      booking_status: bookingStatus,
    },
    { arrayFormat: 'repeat' },
  );

  const response = await get(`${API_URL}/api/user/bookings?${queryString}`);
  return response;
};

const MyClasses = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryParams = qs.parse(searchParams.toString(), { comma: true });

  const tabs = [
    { id: 0, name: 'Up Coming', value: 'upcoming' },
    { id: 1, name: 'Ongoing', value: 'ongoing' },
    { id: 2, name: 'Ended', value: 'ended' },
    { id: 3, name: 'Cancelled', value: 'cancelled' },
  ];

  const getInitialTab = () => {
    const currentStatus = searchParams.get('booking_status');
    const found = tabs.find((tab) => tab.value === currentStatus);
    return found ? found.id : 0;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    const selectedTab = tabs.find((tab) => tab.id === tabId);

    const newParams = {
      ...queryParams,
      booking_status: selectedTab?.value || 'upcoming',
    };

    setSearchParams(newParams);
  };

  const activeStatus = tabs[activeTab]?.value || 'upcoming';

  const { data, isLoading, isError } = useQuery({
    queryKey: ['myClasses', activeStatus, queryParams],
    queryFn: () => fetchMyClasses(queryParams, activeStatus),
    onError: (err) => {
      const message =
        err?.response?.data?.message || err?.message || 'Failed to load classes. Please try again.';
      toast.error(message);
    },
    retry: 1,
  });

  return (
    <div>
      <h2 className="text-xl font-semibold">My Classes</h2>

      <div>
        <Tabs tabs={tabs} activeTab={activeTab} handleTabClick={handleTabClick} />

        <CardContentClasses data={data?.class_bookings} isLoading={isLoading} isError={isError} />
      </div>
    </div>
  );
};

export default MyClasses;
